import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategoryNav() {
  return (
    <section className="py-10 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-xl font-heading font-bold text-foreground-950 mb-6 text-center">
          探索分类
        </h2>
        <div className="flex flex-wrap items-center justify-center gap-2">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={cat.slug === 'all' ? '/category/all' : `/category/${cat.slug}`}
              className="flex items-center gap-1.5 px-4 py-2 rounded-full bg-background-50 text-foreground-700 text-sm font-medium hover:bg-primary-500 hover:text-background-50 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className={`${cat.icon} text-sm`}></i>
              {cat.name}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}